import React, { useEffect, useState } from "react";
import "./ApprovalTickets.css";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import CheckCircle from "@mui/icons-material/CheckCircle";
import CancelRounded from "@mui/icons-material/CancelRounded";
import Close from '@mui/icons-material/Close';
import CheckRounded from "@mui/icons-material/CheckRounded";
import CancelIcon from "@mui/icons-material/Cancel";
import accimg from "../images/accimg.png";
import personImg from '../images/person_image.png';
import axiosApiInstance from "../axios";
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import {
    FormControlLabel,
    Radio,
    RadioGroup,
    Switch,
    Button,
    CircularProgress,
    Chip,
} from "@mui/material";
import Multiselect from "multiselect-react-dropdown";
import ChangeStatus from "../Status/ChangeStatus";
import EditAttachment from "../EditFile/EditAttachment";
import ArticleIcon from "@mui/icons-material/Article";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import NextResParty from "../NextResParty/NextResParty";
import EditRow from "../EditRow/EditRow";
import _ from 'lodash';
import { dateTimeFormat } from '../utils/common';
import Backdrop from '@mui/material/Backdrop';
import { saveAs } from 'file-saver';

const limit = 10;
let scrollDebounce = false;

const ApprovalTickets = ({ term }) => {
    const [ticketCount, setTicketCount] = useState([]);
    const [selectTicket, setSelectTicket] = useState({});
    const [showIgn, setShowIgn] = useState(false);
    const [showFile, setShowFile] = useState(false);
    const [isActiveTicket, setIsActiveTicket] = useState();
    const [selectedUser, setSelectedUser] = useState(1);
    const [selectedValues, setSelectedValues] = useState([]);
    const [isApprovalCommentErrMsg, setIsApprovalCommentErrMsg] = useState(false);
    const [isApproveCommentErrMsg, setIsApproveCommentErrMsg] = useState(false);
    const [comment, setComment] = useState('');
    const [approvalComment, setApprovalComment] = useState('');
    const [responsible, setResponsible] = useState([]);
    const [ticketAttachments, setTicketAttachments] = useState([]);
    const [stopPagination, setStopPagination] = useState(false);
    const [open, setOpen] = useState(false);
    const [ticketNumber, setTicketNumber] = useState();
    const [assignOptions, setAssignOptions] = useState([]);
    const [assignValue, setAssignValue] = useState({});
    const [showParty, setShowParty] = useState(false);
    const [showApprover, setShowApprover] = useState(false);
    const [checked, setChecked] = useState(false);
    const [showStatus, setShowStatus] = useState(false);
    const [showSelectedUsers, setShowSelectedUsers] = useState([]);
    const [isApproveUserErrMsg, setIsApproveUserErrMsg] = useState(false);
    const [approvalData, setApprovalData] = useState({});
    const [isApproverEdit, setIsApproverEdit] = useState(false);
    const [hasUserResponded, setHasUserResponded] = useState(false);
    const employeeId = JSON.parse(localStorage.getItem('id'));
    const userRoles = JSON.parse(localStorage.getItem('userRole'));
    const [higherRole, setHigherRole] = useState('');
    const [loading, setLoading] = useState(false);
    const [approverLoader, setApproverLoader] = useState(false);
    let pageNumber = 1;

    useEffect(() => {
        if (userRoles?.includes('TMS-UI-Admin')) {
            setHigherRole('TMS-UI-Admin');
        } else {
            setHigherRole('');
        }
    }, [userRoles]);

    const editTicket = () => {
        setOpen(!open);
    };

    useEffect(() => {
        getTicketDetails();
    }, [ticketNumber]);

    useEffect(() => {
        getApprovalData();
    }, [ticketNumber])

    const getTicketDetails = () => {
        if (ticketNumber) {
            setTimeout(() => {
                axiosApiInstance
                    .get(`/ticket/${ticketNumber}`)
                    .then((response) => {
                        setSelectTicket(response.data.data);
                        setTicketAttachments(response.data.data.attachments);
                        setShowSelectedUsers([...response.data.data.approverDto]);
                        setComment(response.data.data.approvalRequestDto.requestComment);
                        setSelectedUser(response.data.data.approverDto[0]?.isAllUser ? 1 : 0);
                        setLoading(false);
                        setShowApprover(false);
                    })
                    .catch((err) => console.log(err));
            }, 800);
        }
    }

    useEffect(() => {
        setIsApproverEditable(showSelectedUsers, approvalData);
    }, [showSelectedUsers, approvalData])

    const setIsApproverEditable = (data, approvalStatus) => {
        setIsApproverEdit(true);
        setHasUserResponded(false);
        if (selectTicket.status === 'Work Completed' || selectTicket.status === 'Closed') {
            setIsApproverEdit(false);
            setHasUserResponded(true);
        } else {
            if (higherRole === 'TMS-UI-Admin') {
                if (approvalStatus?.approved === 'Rejected' || approvalStatus?.approved === 'Approved') {
                    setIsApproverEdit(false);
                }
            } else {
                data.forEach(element => {
                    if (element.isApproved !== null) {
                        setIsApproverEdit(false);
                    }
                });
            }
        }
        let isApproverExist = false;
        data.forEach(element => {
            if (element.id === employeeId) {
                isApproverExist = true;
            }
            if (approvalStatus?.approved === 'Rejected' || approvalStatus?.approved === 'Approved' || (element.id === employeeId && element.isApproved !== null)) {
                setHasUserResponded(true);
            }
        });
        if (!isApproverExist) {
            setHasUserResponded(true);
        }
    };

    let tic = ticketCount[0];
    useEffect(() => {
        if (tic) {
            const firstValue = Object.values(tic)[0];
            setTicketNumber(firstValue);
            setIsActiveTicket(firstValue);
        }
    }, [ticketCount]);

    const editParty = () => {
        setShowParty(!showParty);
    };

    const OnSwitchChange = (e) => {
        setChecked(!checked);
        setLoading(true);
    };

    const editIgn = () => {
        setShowIgn(!showIgn);
    };

    const editFile = () => {
        setShowFile(!showFile);
    };

    const inputEvent6 = (event) => {
        setSelectedValues(event);
        if (event.length > 0) {
            setIsApproveUserErrMsg(false);
        }
    };

    useEffect(() => {
        setLoading(true);
        setStopPagination(false);
    }, []);

    const handleScroll = (e) => {
        if (
            window.innerHeight + e.target.documentElement.scrollTop + 1 >=
            e.target.documentElement.scrollHeight &&
            !stopPagination &&
            !scrollDebounce
        ) {
            scrollDebounce = true;
            loadMore();
            setTimeout(function () {
                scrollDebounce = false;
            }, 500);
        }
    };

    useEffect(() => {
        loadMore();
        window.addEventListener("scroll", handleScroll);
        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, [stopPagination, checked]);

    useEffect(() => {
        setStopPagination(false);
        setTicketCount([]);
    }, [checked]);

    const loadMore = () => {
        if (!stopPagination) {
            axiosApiInstance
                .get(`/approval/${pageNumber}/${limit}/${!checked}`)
                .then((res) => {
                    if (res.status === 200) {
                        if (res.data.data.length < limit) {
                            setStopPagination((prevValue) => {
                                return true;
                            });
                        }

                        setTicketCount((prevState) => [...prevState, ...res.data.data]);
                        pageNumber += 1;
                    }
                });
        }
    };

    const approveOrRejectAction = isApprove => {
        if (approvalComment === '') {
            setIsApprovalCommentErrMsg(true);
        } else {
            let data = {
                "ticketId": ticketNumber,
                "comment": approvalComment,
                "isApproved": isApprove
            };

            axiosApiInstance.patch('/approval', JSON.stringify(data)).then(res => {
                if (res?.data?.succeeded === true) {
                    setApprovalComment('');
                    getApprovalData();
                }
            }).catch((error) => {
                console.error("Error:", error);
            });
        }
    }

    const onCommentChange = event => {
        setComment(event.target.value)
        if (event.target.value !== '') {
            setIsApproveCommentErrMsg(false);
        }
    }

    const onApprovalCommentChange = event => {
        setApprovalComment(event.target.value)
        if (event.target.value !== '') {
            setIsApprovalCommentErrMsg(false);
        }
    }

    const editStat = () => {
        setShowStatus(!showStatus);
    };

    const downloadFile = (filename) => {
        axiosApiInstance.get(`/File/${ticketNumber}/${filename}`, {responseType: 'blob'}).then(res => {
          if (res.status === 200) {
            let urlArray = res.config.url && res.config.url.split('/');
            let fileName = urlArray[urlArray.length - 1];
            let blob = new Blob([res.data], {type: 'application/octet-stream'});
            saveAs(blob, fileName);
          }
        }).catch((error) => {
          console.error("Error:", error);
        });
      };

    const deletefile = (fileName) => {
        if (window.confirm("Are you sure that you wanted to delete that file?")) {
            let data = {
                ticketId: `${ticketNumber}`,
                fileName: fileName,
            };

            axiosApiInstance.post('/File/Delete', JSON.stringify(data)).then(res => {
                if (res?.data?.succeeded === true) {
                    setTicketAttachments(
                        ticketAttachments.filter((x) => x.fileName !== fileName)
                    );
                }
            }).catch((error) => {
                console.error("Error:", error);
            });
        }
    };

    const onApproverExpandCancelClick = () => {
        setShowApprover(!showApprover);
        if (!showApprover) {
            setSelectedValues([...showSelectedUsers]);
        }
    }

    const onApprovalSave = () => {
        if (comment === '') {
            setIsApproveCommentErrMsg(true);
        }

        if (selectedValues.length <= 0) {
            setIsApproveUserErrMsg(true);
        }

        if (comment !== '' && selectedValues.length > 0) {
            setApproverLoader(true);
            let approversIds = selectedValues.map(item => item.id);

            let data = {
                "ticketId": selectTicket.ticketId,
                "comment": comment,
                "approvalId": approversIds,
                "isAllUser": !!parseInt(selectedUser),
            };

            axiosApiInstance.post('/approval', JSON.stringify(data)).then(res => {
                if (res?.data?.succeeded === true) {
                    setShowApprover(false);
                    getTicketDetails();
                    setApproverLoader(false);
                }
            }).catch((error) => {
                console.error("Error:", error);
            });
        }
    }
    
    const onChangeAssignValues = (e, value) => {
        setAssignValue(value);
    }

    const onChangeAssignValuesMultiSelect = (e, values, reason, detail) => {
        const seen = new Set();
        const filteredArr = values.filter(el => {
          const duplicate = seen.has(el.id);
          seen.add(el.id);
          return !duplicate;
        });
        setSelectedValues(filteredArr);
        if (values.length > 0) {
          setIsApproveUserErrMsg('');
        }
      }

    const onInputChange = _.debounce((e, value) => {
        if (value !== '') {
            axiosApiInstance
                .get(`/user/${value}`)
                .then((response) => {
                    if (response.data.succeeded) {
                        let updatedArray = response.data.data.map(item => {
                            if (item.id !== employeeId || employeeId !== selectTicket?.submittedId) {
                                return { id: item.id, name: item.display };
                            } else {
                                return null;
                            }
                        });
                        setAssignOptions(updatedArray.filter(item => item !== null));
                    }
                })
                .catch((err) => console.log(err));
        } else {
            setAssignOptions([]);
        }
    }, 500);

    const getApprovalData = () => {
        if (ticketNumber) {
            setTimeout(() => {
                axiosApiInstance
                    .get(`/approval/${ticketNumber}`)
                    .then((response) => {
                        if (response.data.succeeded) {
                            setApprovalData(response.data.data);
                        } else {
                            setApprovalData({});
                        }
                    })
                    .catch((err) => console.log(err));
            }, 800);
        }
    }

    const getSmallString = (string) => {
        let newString = string.split('.');
        let resultString = (newString[0].length > 15 ? newString[0].substring(0, 15)?.concat('...') : newString[0]).concat(newString[0].length > 15 ? `(.${newString[1]})` : `.${newString[1]}`);
        return resultString;
    }

    useEffect(() => {
        getNextResponsiblePartyData();
    }, [ticketNumber]);

    const getNextResponsiblePartyData = () => {
        if (ticketNumber) {
            axiosApiInstance
              .get(`/nextResponsible/${ticketNumber}`)
              .then((res) => setResponsible(res.data.data))
              .catch((err) => console.log(err));
        }
      }

    const savePeopleDetails = () => {
        let data = JSON.stringify({
            "ticketId": ticketNumber,
            "assignId": assignValue.id,
        });

        axiosApiInstance.post('/ticket/AddAssignee', data).then(function (response) {
            if (response.data.succeeded) {
                getNextResponsiblePartyData();
            }
        }).catch((error) => {
            console.log('error : ', error);
        })
        setShowIgn(false);
    }

    return (
        <div className="at-ticket-parent">
            <div className="at-tickets-list">
                <div className="at-left-div">
                    <div className="at-top-ticket">
                        <p>Pending Requests</p>
                        <div>
                            <Switch onChange={OnSwitchChange} checked={checked} />
                        </div>
                        <p>Closed Requests</p>
                    </div>
                    {ticketCount.length === 0
                        ? "Sorry you don't have any tickets"
                        : ticketCount &&
                        ticketCount
                            .filter((tix) => {
                                if (
                                    tix?.title?.toLowerCase()?.includes(term.toLowerCase())
                                ) {
                                    return tix;
                                } else if (
                                    tix.projectTag
                                        .toLowerCase()
                                        .includes(term.toLowerCase())
                                ) {
                                    return tix;
                                } else if (
                                    tix.ticketId
                                        .toString()
                                        .toLowerCase()
                                        .includes(term.toLowerCase())
                                ) {
                                    return tix;
                                }
                            })
                            .map((tix, index) => (
                                <div
                                    className={
                                        (tix.priority === "High" &&
                                            tix.ticketId === isActiveTicket &&
                                            "single-list activered") ||
                                        (tix.priority === "Low" &&
                                            tix.ticketId === isActiveTicket &&
                                            "single-list activeyellow") ||
                                        (tix.priority === "Medium" &&
                                            tix.ticketId === isActiveTicket &&
                                            "single-list activegreen") ||
                                        (tix.ticketId !== isActiveTicket &&
                                            tix.priority === "High" &&
                                            "single-list red") ||
                                        (tix.ticketId !== isActiveTicket &&
                                            tix.priority === "Low" &&
                                            "single-list yellow") ||
                                        (tix.ticketId !== isActiveTicket &&
                                            tix.priority === "Medium" &&
                                            "single-list green")
                                    }
                                    key={index}
                                    onClick={() => {
                                        setTicketNumber(tix.ticketId);
                                        setIsActiveTicket(tix.ticketId);
                                        if (tix.ticketId !== isActiveTicket) {
                                            setLoading(true);
                                        }
                                        window.scrollTo(0, 0);
                                    }}
                                >
                                    <div className="at-single-list-title" key={index}>
                                        <p>ID {tix.ticketId}</p>
                                        <OpenInNewIcon
                                            className="icon-new"
                                            style={{ color: "#3169bd" }}
                                        />
                                    </div>
                                    <div className="at-single-list-desc">{tix.title}</div>
                                    <div className="at-single-list-details">
                                        <div className="at-single-list-stat">
                                            <p>Status</p>
                                            <span>{tix.status}</span>
                                        </div>
                                        <div className="at-single-list-rest">
                                            <p>Project</p>
                                            <span>{tix.projectTag}</span>
                                        </div>
                                        <div className="at-single-list-rest">
                                            <p>Category</p>
                                            <span>{tix.category}</span>
                                        </div>
                                        <div className="at-single-list-rest at-due">
                                            <p>Due Date</p>
                                            <span>{dateTimeFormat(tix.dueDate, true)}</span>
                                        </div>
                                    </div>
                                    <div className="at-single-list-created">
                                        <p>
                                            Created on{" "}
                                            {dateTimeFormat(tix.submittedDate)}
                                        </p>
                                    </div>
                                </div>
                            ))}{" "}
                </div>
            </div>
            {
                ticketCount.length === 0
                ? 
                 <div className="noId">
                <p>No Data Available</p>
            </div>
                : 
                <>
                
               
            {loading ?
                <div className="noId">
                    <CircularProgress />
                </div>
                : ticketCount?.length > 0 ?

                    <div className="at-my-ticket-area-duplicate">
                        <div className="at-div-left-duplicate">
                            <span className="my-span">ID - {selectTicket.ticketId}</span>
                            <b className="at-ticket-name-style">{selectTicket.title}</b>
                            <div className="at-my-ticket-description-duplicate">
                                {selectTicket.description}
                            </div>
                            {Object.keys(approvalData).length > 0 &&
                                <>
                                    <div className="at-approval-request-container">
                                        <b className="at-approval-request-title">Approval Request</b>
                                        <div className="at-approval-user-container" style={{ backgroundColor: '#EaEaEa', border: '1px solid #777' }}>
                                            <div className="at-approval-user-time-container">
                                                <img className="at-approver-person-image" src={personImg} />
                                                <b className="at-approval-section-user-name">{approvalData?.approvalRequest?.name}</b>
                                                <b className="at-approval-section-time">{approvalData?.approvalRequest?.requestedDate && dateTimeFormat(approvalData?.approvalRequest?.requestedDate)}</b>
                                            </div>
                                            <div style={{ paddingLeft: 25 }}>
                                                <label className="at-approval-section-description">{approvalData?.approvalRequest?.requestComment}</label>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="at-head">
                                        <span
                                            className="at-comments-act little"
                                        >
                                            APPROVAL
                                        </span>
                                    </div>

                                    <div className="at-approval-section-container">
                                        {!hasUserResponded &&
                                            <div>
                                                <textarea rows={3} value={approvalComment} onChange={event => onApprovalCommentChange(event)} className='at-approval-comments' placeholder="Enter comment" />
                                                {isApprovalCommentErrMsg && <label className="mytickets-validation-text">This field is required</label>}
                                                <div className="at-approve-reject-btn-container">
                                                    <Button className="at-approve-button" onClick={() => approveOrRejectAction(true)}>Approve</Button>
                                                    <Button className="at-reject-button" onClick={() => approveOrRejectAction(false)}>Reject</Button>
                                                </div>
                                            </div>}
                                        <div>
                                            <b className="at-approval-section-main-title">Approval Response</b>
                                            {approvalData?.approvalResponse?.map((item, index) =>
                                                <div className="at-approval-user-container">
                                                    <div className="at-approval-user-time-container">
                                                        <img className="at-approver-person-image" src={personImg} />
                                                        <b className="at-approval-section-user-name">{item.name}</b>
                                                        <b className="at-approval-section-time">{item?.approvedDate && dateTimeFormat(item?.approvedDate)}</b>
                                                        {item.isApproved === null ?
                                                            <div className="at-approval-section-chip" style={{ padding: '3px 20px', backgroundColor: '#999' }}>
                                                                <label className="at-approval-sub-chip-text">PENDING</label>
                                                            </div> : item.isApproved ?
                                                                <div className="at-approval-section-chip">
                                                                    <CheckRounded sx={{ color: '#FFF', backgroundColor: '#22A', borderRadius: 10, padding: 0, height: 15, width: 15 }} /> <label className="at-approval-sub-chip-text">APPROVED</label>
                                                                </div> :

                                                                <div className="at-approval-section-chip" style={{ backgroundColor: '#f0754d', paddingRight: 17 }}>
                                                                    <Close sx={{ color: '#FFF', backgroundColor: '#db6139', borderRadius: 10, padding: 0, height: 15, width: 15 }} /> <label className="at-approval-sub-chip-text">REJECTED</label>
                                                                </div>}
                                                    </div>
                                                    <div style={{ paddingLeft: 25 }}>
                                                        <label className="at-approval-section-description">{item.responseComment}</label>
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </>}

                        </div>

                        <div className="at-div-center-duplicate">
                            <div className="status-progress">
                                <h1>Ticket Status</h1>
                                {selectTicket.status !== 'Pending For Approval' &&
                                <span className="edit-span" onClick={editStat}>
                                    {showStatus ? <CancelIcon /> : "Edit"}
                                </span>}
                            </div>
                            {showStatus ? (
                                <ChangeStatus
                                    setIsTicketStatusChanged={(value = false) => {
                                        if (value === true) {
                                            getTicketDetails();
                                        }
                                    }}
                                    onStatChange={editStat}
                                    info={ticketNumber}
                                    stat={selectTicket.status}
                                    strtDate={selectTicket.submittedDate}
                                />
                            ) : (
                                <span
                                    className={
                                        (selectTicket.status === "Opened" && "stat-open") ||
                                        (selectTicket.status === "Closed" && "stat-close") ||
                                        (selectTicket.status === "In-Progress" && "stat-progress") ||
                                        (selectTicket.status === "Work Completed" && "stat-work") ||
                                        (selectTicket.status === "Pending For Approval" && "stat-pending") ||
                                        (selectTicket.status === "New" && "stat-new")
                                    }
                                >
                                    {selectTicket.status}
                                </span>
                            )}
                            <div className="add-attach">
                                <h1>Attachment</h1>
                                <span className="icon-attach" onClick={editFile}>
                                    {showFile ? <CancelIcon /> : "+"}
                                </span>
                            </div>
                            {showFile ? (
                                <EditAttachment
                                    setIsTicketStatusChanged={(value = false) => {
                                        if (value === true) {
                                            getTicketDetails();
                                        }
                                    }}
                                    onfChange={editFile}
                                    info={ticketNumber}
                                />
                            ) : (
                                <>
                                    {ticketAttachments < 1 ? (
                                        <p class="empty-attach">None</p>
                                    ) : (
                                        ticketAttachments &&
                                        ticketAttachments.map((attach, id) => (
                                            <>
                                                <div className="single-attachment" key={id}>
                                                    <div className="attach-text">
                                                        <ArticleIcon className="attachment-icon" />
                                                        <div className="attachment-text">
                                                            <p>{getSmallString(attach.fileName)}</p>
                                                            <p>{attach.size}</p>
                                                        </div>
                                                    </div>
                                                    <div className="attach-con">
                                                        <FileDownloadOutlinedIcon
                                                            className="file-attach-icon"
                                                            type="button"
                                                            onClick={() => {
                                                                downloadFile(attach.fileName);
                                                            }}
                                                        >
                                                            Download
                                                        </FileDownloadOutlinedIcon>
                                                        <DeleteOutlineOutlinedIcon
                                                            className="delete-icon"
                                                            type="button"
                                                            onClick={() => deletefile(attach.fileName)}
                                                        />
                                                    </div>
                                                </div>
                                            </>
                                        ))
                                    )}
                                </>
                            )}

                            <div className="resParty-next">
                                <h1>Next Responsible Party</h1>
                                <span className="edit-span" onClick={editParty}>
                                    {showParty ? <CancelIcon /> : "Edit"}
                                </span>
                            </div>
                            {!showParty ? (
                                <>
                                    <p key={ticketNumber} className="res-p">
                                        {selectTicket.nextResponsible}
                                    </p>
                                </>
                            ) : (
                                " "
                            )}
                            {showParty ? (
                                <NextResParty
                                    setIsNextResPartyChanged={(value = false) => {
                                        if (value === true) {
                                            getTicketDetails();
                                        }
                                    }}
                                    onPartyChange={editParty}
                                    info={ticketNumber}
                                />
                            ) : (
                                ""
                            )}

                            <div className="mytickets-approver-container">
                                <div className="mytickets-approver-plus-container">
                                    <b className="mytickets-approver-text">Approver</b>
                                    {isApproverEdit &&
                                        <span className="icon-attach" onClick={onApproverExpandCancelClick}>
                                            {showApprover ? <CancelIcon /> : "+"}
                                        </span>}
                                </div>
                                {!showApprover ?
                                    showSelectedUsers.length > 0 ?
                                        <>
                                            <div className="mytickets-approver-chips-container-main">
                                                {showSelectedUsers.map((item, index) =>
                                                    <div className="mytickets-approver-chips-container">
                                                        <img className="mytickets-approver-person-image" src={personImg} /> <b className="myticets-approver-outside-chip-text">{item.name}</b> {item.isApproved === null ? null : item.isApproved ? <CheckCircle sx={{ color: '#44D' }} /> : <CancelRounded sx={{ color: '#D66' }} />}
                                                    </div>
                                                )}
                                            </div>
                                            <RadioGroup className="mytickets-radio-buttons-container" row aria-label="priority" name="row-radio-buttons-group" value={selectedUser}>
                                                <FormControlLabel disabled value={0} control={<Radio size="small" />} label='Any Approver' className="myticket-radio-button-label" />
                                                <FormControlLabel disabled value={1} control={<Radio size="small" />} label='All Approvers' className="myticket-radio-button-label" />
                                            </RadioGroup>
                                        </>
                                        :
                                        <p class="empty-attach">None</p>
                                    :
                                    <div>
                                        <textarea placeholder="Comment" value={comment} onChange={event => onCommentChange(event)} rows={2} className='mytickets-textarea-style' />
                                        {isApproveCommentErrMsg && <label className="mytickets-validation-text">This field is required</label>}
                                        <div className="mytickets-approver-sub-container">
                                            <Autocomplete
                                                id="free-solo-demo"
                                                className="newticket-autocomplete-style"
                                                freeSolo
                                                multiple
                                                value={selectedValues}
                                                onChange={(event, value, reason, detail) => onChangeAssignValuesMultiSelect(event, value, reason, detail)}
                                                duplicate={false}
                                                onInputChange={(e, v) => onInputChange(e, v)}
                                                options={assignOptions}
                                                getOptionLabel={(option) => option.name}
                                                renderInput={(params) => <TextField {...params} placeholder='Select Approver' />}
                                                renderTags={(values, getTagProps) => {
                                                const seen = new Set();
                                                const filteredArr = values.filter(el => {
                                                    const duplicate = seen.has(el.id);
                                                    seen.add(el.id);
                                                    return !duplicate;
                                                });
                                                return (
                                                    filteredArr.map((option, index) => (
                                                    <Chip label={option.name} {...getTagProps({ index })}></Chip>
                                                    ))
                                                )
                                                }}
                                            />
                                            {isApproveUserErrMsg && <label className="mytickets-validation-text">This field is required</label>}
                                            <RadioGroup className="mytickets-radio-buttons-container" row aria-label="priority" name="row-radio-buttons-group" value={selectedUser} onChange={(e) => {
                                                setSelectedUser(e.target.value);
                                            }}>
                                                <FormControlLabel value={0} control={<Radio size="small" />} label='Any User' className="myticket-radio-button-label" />
                                                <FormControlLabel value={1} control={<Radio size="small" />} label='All User' className="myticket-radio-button-label" />
                                            </RadioGroup>
                                            <div className="mytickets-save-cancel-buttons">
                                                <Button className="mytickets-save-button" onClick={onApprovalSave}>Save</Button>
                                                <Button className="mytickets-cancel-button" onClick={() => setShowApprover(false)}>Cancel</Button>
                                            </div>
                                        </div>
                                    </div>
                                }
                            </div>

                            <div className="mytickets-approval-status-container">
                                <label className="mytickets-approval-status-title">Approval Status</label>
                                <label className="mytickets-approval-status-text">{approvalData?.approved ? approvalData?.approved : <p class="empty-attach">None</p>}</label>
                            </div>

                            <div className="my-details-head">
                                <h1>Details</h1>
                                <span className="edit-span" onClick={editTicket}>
                                    {open ? <CancelIcon /> : "Edit"}
                                </span>
                            </div>
                            <div className="my-details-content">
                                {open ?
                                    <EditRow
                                        setIsDetailsChanged={(value = false) => {
                                            if (value === true) {
                                                getTicketDetails();
                                            }
                                        }}
                                        onStateChange={editTicket}
                                        info={ticketNumber}
                                    />
                                    :
                                    <>
                                        <div className="details-div">
                                            <span>ID</span> <p>{selectTicket.ticketId}</p>
                                        </div>
                                        <div className="details-div">
                                            <span>Title</span> <p>{selectTicket?.title && selectTicket?.title?.length > 15 ? selectTicket?.title?.substring(0, 15)?.concat('...') : selectTicket?.title}</p>
                                        </div>
                                        <div className="details-div">
                                            <span>Project Tag</span> <p>{selectTicket.projectTag}</p>
                                        </div>
                                        <div className="details-div">
                                            <span>Priority</span> <p>{selectTicket.priority}</p>
                                        </div>
                                        <div className="details-div">
                                            <span>Category</span> <p>{selectTicket.category}</p>
                                        </div>
                                        <div className="details-div">
                                            <span>Sub Category</span> <p>{selectTicket?.subCategory && selectTicket?.subCategory?.length > 15 ? selectTicket?.subCategory?.substring(0, 15)?.concat('...') : selectTicket?.subCategory}</p>
                                        </div>
                                        <div className="details-div">
                                            <span>Submitted By</span> <p>{selectTicket.submittedBy}</p>
                                        </div>
                                        <div className="details-div">
                                            <span>Submitted Date</span>{" "}
                                            <p>{dateTimeFormat(selectTicket.submittedDate, true)}</p>
                                        </div>
                                        <div className="details-div">
                                            <span>Due Date</span>{" "}
                                            <p>{dateTimeFormat(selectTicket.dueDate, true)}</p>
                                        </div>
                                    </>}
                            </div>
                            <div className="peep">
                                <h1>People</h1>
                                <p className="edit-p" onClick={editIgn}>
                                    {showIgn ? <CancelIcon /> : "Edit"}
                                </p>
                            </div>
                            {showIgn ?
                                <div className="at-approver-sub-container">
                                    <Autocomplete
                                        id="free-solo-demo"
                                        className="at-autocomplete-style"
                                        freeSolo
                                        onChange={(event, value) => onChangeAssignValues(event, value)}
                                        duplicate={false}
                                        onInputChange={(e, v) => onInputChange(e, v)}
                                        options={assignOptions}
                                        getOptionLabel={(option) => option.name}
                                        renderInput={(params) => <TextField {...params} placeholder='select' />}
                                    />
                                    <div className="at-save-cancel-buttons">
                                        <Button className="at-save-button" onClick={savePeopleDetails}>Save</Button>
                                        <Button className="at-cancel-button" onClick={() => setShowIgn(false)}>Cancel</Button>
                                    </div>
                                </div> :
                                <div className="people">
                                    {responsible.map((nxt) => (
                                        <div key={nxt.id} className="peo-frag">
                                            <img
                                                src={nxt.profilePath ? nxt.profilePath : accimg}
                                                className="img-pro"
                                            />
                                            <p>{nxt.fullName}</p>
                                        </div>
                                    ))}
                                </div>

                            }
                        </div>
                    </div> : null}
                    </>
            }
            <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={approverLoader}
            >
                <CircularProgress color="inherit" />
            </Backdrop>
        </div>
    );
};

export default ApprovalTickets;
